import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgModalCloseButton = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			opacity: .2,
			cx: 12,
			cy: 12,
			r: 12,
			fill: "#A6A9BA"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1503_61903)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M15.5999 15.5984L8.3999 8.39844",
				stroke: "#14181F",
				strokeOpacity: .5,
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M15.5999 8.39844L8.3999 15.5985",
				stroke: "#14181F",
				strokeOpacity: .5,
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1503_61903",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 9.6,
				height: 9.6,
				fill: "white",
				transform: "translate(7.19995 7.19922)"
			})
		}) })
	]
});
export default SvgModalCloseButton;
